import { Component, computed, inject, input } from '@angular/core';
import { SingleSelectDropdownComponent } from '@cumlaude/shared-components-inputs';
import { Option } from '@cumlaude/shared-utils';
import { QpName, QpValue, QueryParamStateService } from '../../../services/query-param-state.service';

@Component({
	selector: 'app-weergave-optie',
	templateUrl: './weergave-optie.component.html',
	styleUrls: ['./weergave-optie.component.scss'],
	imports: [SingleSelectDropdownComponent],
})
export class WeergaveOptieComponent<N extends QpName> {
	protected readonly qp = inject(QueryParamStateService);

	readonly param = input.required<N>();

	readonly enum = input.required<{ [k: string]: QpValue<N> }>();

	readonly value = input.required<QpValue<N>>();

	readonly label = input.required<string>();

	readonly filter = input<(val: QpValue<N>) => boolean>(() => true);

	readonly allValues = computed(() => Object.values(this.enum()).filter(this.filter()));

	readonly opties = computed(() => this.allValues().map((val) => new Option(val)));

	readonly optie = computed(() => this.opties().find((o) => o.value === this.value()));
}
